import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ClientBookingPaymentService } from '../services'
import { OrderPaymentStepDto } from '../types'
import { defaultQueryOptions } from './common'
import { useRef } from 'react'

export const CLIENT_POLL_ORDER_PAYMENT_STEP_ATTEMPT_LIMIT = 5

export const useClientPollOrderPaymentStep = (
  locationName: string,
  orderId: string,
  paymentId: string,
  { enabled = true }: { enabled?: boolean } = {}
): UseQueryResult<OrderPaymentStepDto> & { isPollingComplete: boolean } => {
  const isCompleteRef = useRef(false)

  const query = useQuery<OrderPaymentStepDto>({
    queryKey: ['clientPollOrderPaymentStep', locationName, orderId, paymentId],
    queryFn: () => ClientBookingPaymentService.getStep(locationName, orderId, paymentId),
    ...defaultQueryOptions,
    enabled,
    refetchInterval: (payment, query) => {
      if (
        (!payment || payment.step === 'PENDING') &&
        query.state.dataUpdateCount < CLIENT_POLL_ORDER_PAYMENT_STEP_ATTEMPT_LIMIT
      ) {
        return 2000
      }

      isCompleteRef.current = true
      return false
    },
  })

  return { ...query, isPollingComplete: isCompleteRef.current }
}
